<template>
    <div class="wework-steps-bottom">
        <v-button v-if="cancelBtnTxt" size="large" class="wework-steps-bottom-btn" @click="cancelBtnClick">{{
            cancelBtnTxt
        }}</v-button>
        <v-button
            status="primary"
            size="large"
            class="wework-steps-bottom-btn"
            :disabled="btnDisabled"
            @click="btnClick"
            >{{ btnTxt }}</v-button
        >
        <p v-if="descTxt" class="wework-steps-bottom-txt">{{ descTxt }}</p>
    </div>
</template>

<script>
export default {
    props: {
        isLastStep: {
            type: Boolean,
            default: false
        },

        descTxt: {
            type: String,
            default: ''
        },

        btnDisabled: {
            type: Boolean,
            default: true
        },

        confirmBtnTxt: {
            type: String,
            default: ''
        },

        cancelBtnTxt: {
            type: String,
            default: ''
        }
    },

    data() {
        return {};
    },

    computed: {
        btnTxt() {
            return this.confirmBtnTxt || (this.isLastStep ? this.$t('完成') : this.$t('下一步'));
        }
    },

    methods: {
        btnClick() {
            this.$emit('btnClick');
        },

        cancelBtnClick() {
            this.$emit('cancelBtnClick');
        }
    }
};
</script>
<style scoped lang="less">
@import './steps-bottom.less';
</style>
